<template>
  <div id="add-hashtag">
    <alert-dynamic-component
      :key="res_key"
      v-if="res == 'berhasil'"
      type="success"
      title="Berhasil!"
      subtitle="Hashtag berhasil ditambahkan."
    />
    <alert-dynamic-component
      :key="res_key"
      v-if="res == 'gagal'"
      type="danger"
      title="Gagal!"
      :subtitle="res_message"
    />
    <form action="#" v-on:submit.prevent="submitForm">
      <div class="form-group input-group input-group-left">
        <label for="addhashtag">Hashtag</label>
        <div class="form-group input-group transparent">
          <div class="input-group-prepend">
            <span class="input-group-text transparent"
              ><i class="bi bi-hash"></i
            ></span>
          </div>
          <input
            type="text"
            v-model="hashtag"
            placeholder="Masukan Hashtag"
            class="form-control"
            @input="removeSymbols"
            required
          />
        </div>
        <small class="text-muted d-block">
          <i class="bi bi-info-circle mr-1"></i> Hashtag hanya untuk Instagram
          dan masukkan tanpa tanda (#)
        </small>
      </div>
      <div class="form-group" align="right">
        <button type="button" class="btn btn-danger m-r-5" data-dismiss="modal">
          Batal
        </button>
        <button type="submit" class="btn btn-primary">Simpan</button>
      </div>
    </form>
  </div>
</template>

<script>
import alert_dynamic from "@/views/components/alert_dynamic.vue";

export default {
  name: "modal_add_hashtag",
  components: {
    "alert-dynamic-component": alert_dynamic,
  },
  data() {
    return {
      hashtag: null,
      res: null,
      id_project:
        this.$store.getters.user.id_project != 0
          ? this.$store.getters.user.id_project
          : parseInt(atob(this.$route.query.ref)),
      res_key: 0,
      res_message: "",
    };
  },
  methods: {
    removeSymbols: function() {
      this.hashtag = this.hashtag.replace(/[^a-zA-Z0-9_]/g, "");
    },
    submitForm: function() {
      this.res = null;
      let params = {
        _id: this.id_project,
        hashtag: this.$sanitize(this.hashtag),
      };
      let api = process.env.VUE_APP_API_URL + "hashtag-add";
      this.$http
        .post(api, params)
        .then((response) => {
          if (response.status == 200) {
            this.$parent.$parent.getHashtag();
            this.hashtag = null;
            this.res = "berhasil";
          } else {
            this.res = "gagal";
          }
        })
        .catch((error) => {
          this.res_message = "Hashtag gagal ditambahkan. ";
          this.res_message += error.response.data.status;
          this.res = "gagal";
        })
        .finally(() => {
          this.res_key++;
        });
    },
  },
};
</script>
